import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupService } from '../services/signup.service';
import { PaymentService } from '@app/payments/services/payment.service';
import { PaymentCardDetailsComponent } from '@app/payments/payment-card-details/payment-card-details.component';
import { SlideCommonService } from '@app/application/common/slide-common.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';

@Component({
    selector: 'app-first-payment',
    imports: [ CommonModule, PaymentCardDetailsComponent ],
    templateUrl: './first-payment.component.html',
    styleUrl: './first-payment.component.scss'
})
export class FirstPaymentComponent {

    @Input() firstPaymentContent!: FirstPaymentContent;

    constructor(
        private signupService: SignupService,
        private paymentService: PaymentService,
        private slideCommon: SlideCommonService,
        private logger: LoggerService
    ) {
        this.vm.slides = {
            makePayment: "makePayment",
            makePaymentComplete: false,
            cardDetails: "cardDetails",
            cardDetailsComplete: false
        };
    }

    currentSlide = 'firstPayment';
    referenceData = {};
    active = this.signupService.getActive();
    model = this.signupService.getNextOfKinModel();
    errors = [];
    applicationId = sessionStorage.getItem('connect.applicationId');
    vm: any = {};

    back() {
        this.signupService.goBack('firstPayment');
        this.slideCommon.scroll(this.vm.active.active);
    }

    save() {
        this.moveToNextSlide();
    }

    moveToNextSlide() {
        const order = this.paymentService.getOrder();
        this.logger.info("order details", order);
        if (order.code !== "" && order.code !== null) {
            this.paymentService.setOrder({});
        }
    }
}

export type FirstPaymentContent = {
    paySecurelyButtonText: string,
    continuePaymentButtonText: string,
    enterAmountHeading: string,
    enterAmountSubHeading: string,
    enterAmountBody: string,
    cardDetailsHeading: string,
    cardDetailsSubHeading: string,
    cardDetailsBody: string,
    failedPaymentMessage: string,
    errorPaymentMessage: string,
    thankYouPage: string,
    processingPaymentTitle: string,
    processingPaymentBody: string,
    paymentCardPageUrl: string
}
